import apiClient from "./axios";

/**
 * 航班事件日志API
 */
export const flightEventLogApi = {
    /**
     * 获取航班事件日志列表
     * @param {Object} params 查询参数
     * @returns {Promise<Object>} 事件日志列表
     */
    getFlightEventLogs: async (params = {}) => {
        try {
            const response = await apiClient.get("/v1/flight-event-logs", { params });
            return response;
        } catch (error) {
            console.error("获取航班事件日志失败:", error);
            throw error;
        }
    },

    /**
     * 获取单个航班的事件日志
     * @param {number} flightId 航班ID
     * @param {Object} params 查询参数
     * @returns {Promise<Object>} 事件日志列表
     */
    getFlightEventLogsByFlightId: async (flightId, params = {}) => {
        try {
            const queryParams = {
                flight_operation_id: flightId,
                ...params,
            };
            const response = await apiClient.get("/v1/flight-event-logs", { params: queryParams });
            return response;
        } catch (error) {
            console.error(`获取航班ID=${flightId}的事件日志失败:`, error);
            throw error;
        }
    },

    /**
     * 创建航班事件日志
     * @param {Object} data 日志数据
     * @returns {Promise<Object>} 创建结果
     */
    createFlightEventLog: async (data) => {
        try {
            const response = await apiClient.post("/v1/flight-event-logs", data);
            return response;
        } catch (error) {
            console.error("创建航班事件日志失败:", error);
            throw error;
        }
    },
};

export default flightEventLogApi;
